import http from "./http_common";

class PatientService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  getPatient(payload) {
    var queryString = this.queryString(payload);
    return http.get(`patient/list/filter?${queryString}`);
  }

  HSPatientData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patient/consultation/list/filter?${queryString}`);
  }

  getClinicData(payload) {
    return http.get(`/Clinic_Master/list/filter?clinic_Id=${payload}`);
  }
  getHSClinicData(payload) {
    return http.get(
      `/Clinic_Master/health-summar/list/filter?clinic_Id=${payload}`,
    );
  }
  patientUpdate(payload) {
    return http.put(`patient/${payload.id}`, payload);
  }
  AddFamilyMember(payload) {
    return http.post(`patient/`, payload);
  }
  getUserName(data) {
    return http.get(`/patientAppointment/get-user-name?appointmentId=${data}`);
  }
  updateMedicalRecords(data) {
    return http.post(`patientHistoryAccess/save-from-invite-link`, data);
  }

  patientWatchData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/list?${queryString}`);
  }

  GarminRespirationDailyData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`webhooks/garmin/dayWiseList?${queryString}`);
  }

  GarminRespirationWeeklyData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/weeklyWiseList?${queryString}`);
  }

  patientMembershipStatus(payload) {
    return http.post("/PatientMembership/planValid", payload);
  }

  PatientList(payload) {
    const queryString = new URLSearchParams(payload).toString();
    return http.get(`/patient/list/filter?${queryString}`);
  }

  AllConsReasons(data) {
    const queryString = this.queryString(data);
    return http.get(
      `/ChiefComplaintMaster/list/filter?pageNo=1&pageSize=30&${queryString}`,
    );
  }

  RelationList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/RelationMaster/list/filter?${queryString}`);
  }

  AddPatient(payload) {
    return http.post("/patient/", payload);
  }

  patientMembershipDet(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/PatientMembershipServiceDetails/list/filter?${queryString}`,
    );
  }

  procedureReqList(data) {
    const queryString = this.queryString(data);
    return http.get(`/procedureRequest/list/filter?${queryString}`);
  }

  getDentalFormData(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/consultationSpecialityToothDetails/list/filter?${queryString}`,
    );
  }

  SendPrescriptionFile(payload) {
    return http.post("/RxPrescriptionOrder/", payload);
  }
}

export default new PatientService();
